export default `
banner {
    ... on ds_BannerA_Entry {
        bannerA_Images {
            id
            url @transform(width: 1920, height: 1080)
            focalPoint
        }
        bannerA_Video {
            ... on ds_VideosSection_Entry {
                videoUrl
                videoType
                videoFile {
                    url
                }
            }
        }
        bannerA_Content
        bannerA_Buttons {
            url
            text
            target
            ... on bannerA_Buttons_Entry_LinkType {
                buttonStyle
                icon {
                    name
                    set
                    type
                }
            }
            ... on bannerA_Buttons_Url_LinkType {
                buttonStyle
                icon {
                    name
                    set
                    type
                }
            }
            ... on bannerA_Buttons_Custom_LinkType {
                buttonStyle
                icon {
                    name
                    set
                    type
                }
            }
            ... on bannerA_Buttons_Email_LinkType {
                buttonStyle
                icon {
                    name
                    set
                    type
                }
            }
            ... on bannerA_Buttons_Phone_LinkType {
                buttonStyle
                icon {
                    name
                    set
                    type
                }
            }
        }

        bannerA_Alignment
        bannerA_Overlay
        bannerA_CustomOverlay
        bannerA_OverlayOpacity
        bannerA_ContentContainerWidth
        bannerA_ShowBorder
        bannerA_BorderColorPalette
        bannerA_ColorTheme
        bannerA_ShowLoadingIndicator
    }
}
`